/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-api\\modules\\index.js"), RootInstanceProvider = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

var CardBox, PureRenderMixin, React, ReactDOM, css;

React = require('react');

ReactDOM = require('react-dom');

PureRenderMixin = require('react-addons-pure-render-mixin');

CardBox = require('./card-box');

css = require('../css/active-cards.styl');

module.exports = React.createClass({
  mixins: [PureRenderMixin],
  displayName: 'ActiveCards',
  render: function() {
    var cardBoxes, columnClass;
    columnClass = css['active-cards'];
    cardBoxes = this.props.cards.items.map((function(_this) {
      return function(card, i) {
        return React.createElement(CardBox, {
          "key": card.value,
          "type": card.type
        }, card.value);
      };
    })(this));
    return React.createElement("div", {
      "className": css['active-cards']
    }, cardBoxes);
  }
});


/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("C:\\Projects\\karty-proti-lidskosti\\karty-frontend\\node_modules\\react-hot-loader\\makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "active-cards.cjsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/active-cards.cjsx
 ** module id = 246
 ** module chunks = 0
 **/